import React from 'react'
import { Select as MSelect, SelectProps as MSelectProps } from '@mantine/core'
import { createStyles } from '@mantine/styles'

const useRootStyles = createStyles((theme, _params) => {
  return {
    custom: {},

    black: {
      width: '100%',
    },
  }
})

const useInputStyles = createStyles((theme, _params) => {
  return {
    custom: {},

    black: {
      backgroundColor: theme.colors.brandBlack[6],
      color: theme.white,
      '&:hover': {
        backgroundColor: theme.colors.brandBlack[5],
      },
    },
  }
})

export type SelectProps = MSelectProps & {
  styleType?: 'custom' | 'black'
}

export function Select({ styleType = 'black', ...props }: SelectProps) {
  const { classes: rootClasses } = useRootStyles()
  const { classes: inputClasses } = useInputStyles()

  return (
    <MSelect
      classNames={{
        root: rootClasses[styleType],
        input: inputClasses[styleType],
      }}
      searchable
      {...props}
    >
      {props.children}
    </MSelect>
  )
}
